import urls from "../../global/constants/UrlConstants";
import { getCallParams, makeCall } from "../../utils/service";

export async function getRegistrationSubmissions(payload: {
  pageNo?: number;
  pageSize?: number;
  search?: string;
  formId?: string;
  projectId?: string;
  source?: string;
  organizationId?: string;
}) {
  const page = payload.pageNo ?? 0;
  const limit = payload.pageSize ?? 25;
  const params = new URLSearchParams({
    page: String(page),
    limit: String(limit),
    search: payload.search || "",
  });
  if (payload.formId) params.set("formId", payload.formId);
  if (payload.projectId) params.set("projectId", payload.projectId);
  if (payload.source) params.set("source", payload.source);
  if (payload.organizationId) params.set("organizationId", payload.organizationId);

  const callParams = await getCallParams("GET");
  return makeCall(
    `${urls.url_prod}/registration/submissions?${params.toString()}`,
    callParams
  );
}

export async function getRegistrationFormCounts() {
  const callParams = await getCallParams("GET");
  return makeCall(`${urls.url_prod}/registration/form-counts`, callParams);
}

export async function getRegistrationForms() {
  const callParams = await getCallParams("GET");
  return makeCall(`${urls.url_prod}/registration/forms`, callParams);
}

export async function convertRegistrationToLead(submissionId: string) {
  const callParams = await getCallParams("POST", {});
  return makeCall(
    `${urls.url_prod}/registration/submissions/${encodeURIComponent(
      submissionId
    )}/convert-to-lead`,
    callParams
  );
}

const EXPORT_TIMEOUT_MS = 180000;

export async function exportRegistrationSubmissions(payload: {
  search?: string;
  formId?: string;
  projectId?: string;
  source?: string;
}) {
  const params = new URLSearchParams();
  if (payload.search) params.set("search", payload.search);
  if (payload.formId) params.set("formId", payload.formId);
  if (payload.projectId) params.set("projectId", payload.projectId);
  if (payload.source) params.set("source", payload.source);

  const callParams = await getCallParams("GET");
  const qs = params.toString();
  return makeCall(
    `${urls.url_prod}/registration/submissions/export${qs ? `?${qs}` : ""}`,
    callParams,
    EXPORT_TIMEOUT_MS
  );
}
